<template>
    <section class="main-visual">
        <main-visual-video />
        <v-container class="container--large">
            <div class="main-visual__text">
                <h1 class="logo">
                    <img src="/images/main/visual/logo.svg" alt="SAGE LAW" eager data-aos="fade-up" data-aos-delay="800" />
                </h1>
                <p class="subtitle">
                    <img src="/images/main/visual/subtitle.svg" alt="CORPORATE ADVISORY & DISPUTES" eager data-aos="fade-up" data-aos-delay="1100" />
                </p>
            </div>
        </v-container>
        <main-visual-scrolldown />
    </section>
</template>

<script>
import MainVisualScrolldown from "./main-visual-scrolldown.vue";
import mainVisualVideo from "./main-visual-video.vue";
export default {
    components: { mainVisualVideo, MainVisualScrolldown },
};
</script>

<style lang="scss" scoped>
.main-visual {
    width: 100%;
    height: 100vh;
    position: relative;
    overflow: hidden;
    background: url(/images/main/visual/visual.jpg) no-repeat center / cover;
    ::v-deep(.main-visual-video) {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 100%;
        aspect-ratio: 16/ 9;
        min-height: 100vh;
        transform: translate(-50%, -50%);
        pointer-events: none;
        min-width: calc(100vh * (16 / 9));
        z-index: -1;
        transition: z-index 0s 0.5s;
        &.ready {
            z-index: initial;
        }
    }
    ::v-deep(#player) {
        width: 100%;
        height: 100%;
    }
    &::before,
    &::after {
        content: "";
        width: 100%;
        position: absolute;
        left: 0;
        bottom: 0;
    }
    &::before {
        height: 100%;
        background: rgba(0, 0, 0, 0.4);
        z-index: 1;
    }
    &::after {
        height: 35%;
        background: linear-gradient(to bottom, transparent, #fff);
        z-index: 2;
    }
    > .container {
        height: 100%;
        padding-top: var(--header-body) !important;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        z-index: 1;
    }
    &__text {
        max-width: 100%;
        .logo,
        .subtitle {
            display: block;
            max-width: 618px;
            overflow: hidden;
            filter: drop-shadow(0 0 8px rgba(0, 0, 0, 0.6));
            img {
                display: block;
                max-width: 100%;
                margin: 0 auto;
            }
        }
        .logo {
            margin: initial;
        }
        .subtitle {
            margin-top: 18px;
        }
    }
}
@media (min-width: 1024px) {
    .main-visual {
        &__text {
            .subtitle {
                margin-top: 25px;
            }
        }
        ::v-deep(.main-visual-video) {
            min-width: initial;
        }
    }
}
</style>
